import { BaseApi } from './base';
import type { Effect } from './types';

export class EffectsApi extends BaseApi {
  /** Get active effects for a managed user (manager only) */
  async getUserEffects(userId: string): Promise<Effect[]> {
    return await this._request<Effect[]>(`/effects/user/${userId}`, {
      method: 'GET',
    });
  }

  /** Get active effects for the current user */
  async getMyEffects(): Promise<Effect[]> {
    return await this._request<Effect[]>('/effects/me', {
      method: 'GET',
    });
  }

  /** Cancel (delete) an active effect (manager only) */
  async cancelEffect(effectId: string): Promise<{ deleted: boolean }> {
    return await this._request<{ deleted: boolean }>(`/effects/${effectId}`, {
      method: 'DELETE',
    });
  }
}
